export default "__VITE_ASSET__D0NIT2om__"